import React, { Component } from 'react';
import './App.css';


class Overlay extends Component {
  constructor(props){
    super(props);
    this.state = props;
  }

  componentWillReceiveProps(nextProps) {
    const { metric } = nextProps;
    if (!metric) {
      return null;
    }

    const children = Array.from(document.getElementsByClassName("overlay-metrics")[0].children);

    children.map((item) => {
      if (item.className !== 'metric ' + metric && item.className !== 'metric-title') {
        document.getElementsByClassName(item.className)[0].style['color'] = '#000';
        document.getElementsByClassName(item.className)[0].style['background-color'] = 'rgb(255,255,255)';
      } else {
        document.getElementsByClassName(item.className)[0].style['color'] = '#fff';
        document.getElementsByClassName(item.className)[0].style['background-color'] = '#418ac9';
      }
    });
  }

  render() {
    return (
      <div>
        <div className="overlay-metrics">
          <div className="metric-title" >Metrics</div>
          <div className="metric co" onClick={(e) => { this.props.changeMetric("co"); }}>
            <p className="metric-text">Carbon Monoxide</p>
            <div className="metric-marker">
              <i className="fa fa-map-marker"></i>
            </div>
          </div>
          <div className="metric temperature" onClick={() => { this.props.changeMetric("temperature"); }}>
          <p className="metric-text">Temperature</p>
            <div className="metric-marker">
              <i className="fa fa-map-marker"></i>
            </div></div>
          <div className="metric humid" onClick={() => { this.props.changeMetric("humid"); }}>
          <p className="metric-text">Humidity</p>
            <div className="metric-marker">
              <i className="fa fa-map-marker"></i>
            </div></div>
          <div className="metric noise" onClick={() => { this.props.changeMetric("noise"); }}>
          <p className="metric-text">Noise</p>
            <div className="metric-marker">
              <i className="fa fa-map-marker"></i>
            </div></div>
          <div className="metric lux" onClick={() => { this.props.changeMetric("lux"); }}>
          <p className="metric-text">Lux</p>
            <div className="metric-marker">
              <i className="fa fa-map-marker"></i>
            </div>
          </div>
          <div className="metric objectemp" onClick={(e)=>{this.props.changeMetric("objectemp")}}>
          <p className="metric-text">Surface Temp</p>
            <div className="metric-marker">
              <i className="fa fa-map-marker"></i>
            </div>
          </div>
          <div className="metric pm2" onClick={(e)=>{this.props.changeMetric("pm2")}}>
          <p className="metric-text">Particulate PM2.5</p>
            <div className="metric-marker">
              <i className="fa fa-map-marker"></i>
            </div>
          </div>   
          <div className="metric pm3" onClick={(e)=>{this.props.changeMetric("pm3")}}>
          <p className="metric-text">Particulate PM10</p>
            <div className="metric-marker">
              <i className="fa fa-map-marker"></i>
            </div>
          </div>         
          <div className="metric wind" onClick={(e)=>{this.props.changeMetric("wind")}}>
          <p className="metric-text">Wind</p>
            <div className="metric-marker">
              <i className="fa fa-map-marker"></i>
            </div>
          </div>             

        </div>
        <div className="overlay-legend">
          <div className="legend-title">Legends</div>
          <div className="legend-high">
            <div className="legend-high-color"></div>
            <div className="legend-high-text">High</div>
          </div>
          <div className="legend-medium-high">
            <div className="legend-medium-high-color"></div>
            <div className="legend-medium-high-text">Medium-High</div>
          </div>
          <div className="legend-medium">
            <div className="legend-medium-color"></div>
            <div className="legend-medium-text">Medium</div>
          </div>
          <div className="legend-medium-low">
            <div className="legend-medium-low-color"></div>
            <div className="legend-medium-low-text">Medium-Low</div>
          </div>
          <div className="legend-low">
            <div className="legend-low-color"></div>
            <div className="legend-low-text">Low</div>
          </div>
          <div className="legend-no">
            <div className="legend-no-color"></div>
            <div className="legend-no-text">No Data</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Overlay;



// WEBPACK FOOTER //
// ./src/Overlay.js